(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = s => root.querySelector(s), all = s => [...root.querySelectorAll(s)];
    const variants = JSON.parse(q('[data-variants]').textContent);
    const route = window.Shopify?.routes?.root || '/';
    const currency = root.dataset.currency || 'USD';
    const money = n => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency', currency}).format(n / 100);
    let quantity = 1, busy = false;
    const selects = all('[data-size]');
    const variantAt = i => variants.find(v => String(v.id) === selects[i].value);
    const selected = () => Array.from({length:quantity}, (_,i) => variantAt(i));
    const allowed = () => {
      const counts = new Map();
      for (const v of selected()) {
        if (!v?.available) return false;
        counts.set(v.id, (counts.get(v.id) || 0) + 1);
        if (v.tracked && v.policy !== 'continue' && counts.get(v.id) > v.stock) return false;
      }
      return true;
    };
    const saving = (v, count) => {
      const cents = count >= 2 ? 500 : 0;
      return currency === 'USD' ? cents : Math.round(v.price * cents / Number(v.shopBase || root.dataset.basePrice));
    };
    const referencePrice = v => v.compareAt > v.price ? v.compareAt : v.price;
    const track = q('[data-gallery]'), slides = all('.tlf-slide');
    const behavior = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
    let activeIndex = 0;
    const visibleSlides = () => slides.filter(slide => !slide.hidden);
    const go = (index, animate = true) => {
      const position = visibleSlides().indexOf(slides[index]);
      if (position < 0) return;
      activeIndex = index;
      track.scrollTo({left:position * track.clientWidth, behavior:animate ? behavior() : 'instant'});
      sync();
    };
    const showFinish = v => {
      all('[data-pet-variant]').forEach(node => node.hidden = node.dataset.petVariant !== String(v.id));
      go(slides.findIndex(slide => !slide.hidden), false);
      q('[data-pet-photo-selection]').textContent = v.name;
      all('[data-pet-feature]').forEach(img => {
        const source = img.dataset.petFeature === 'detail' && String(v.id) === '67899132969184'
          ? v.photo.replace('pet-hero-', 'pet-empty-') : v.photo;
        img.src = source;
        const isSmall = String(v.id) === '67899133001952';
        img.srcset = `${source.replace('.jpg', '-small.jpg')} ${isSmall ? 500 : 600}w, ${source} ${isSmall ? 900 : 1100}w`;
        img.width = img.height = isSmall ? 900 : 1100;
        img.alt = String(v.id) === '67899132969184'
          ? img.dataset.petFeature === 'hero' ? 'Black pet travel seat with a spaniel in a parked vehicle.' : 'Black pet travel seat, mesh sides and rear pockets.'
          : 'Small grey pet travel seat with a dachshund in a parked vehicle.';
      });
    };
    const update = () => {
      const first = variantAt(0), items = selected();
      const total = items.reduce((sum,v) => sum + v.price - saving(v, quantity), 0);
      root.dataset.setCount = String(quantity);
      all('[data-bundle]').forEach(input => {
        input.checked = Number(input.value) === quantity;
        input.closest('label').classList.toggle('is-selected', input.checked);
        input.disabled = busy;
      });
      q('[data-second]').hidden = quantity < 2;
      selects.forEach(select => select.disabled = busy);
      q('[data-id]').value = first.id; q('[data-quantity]').value = quantity;
      q('[data-express-id]').value = first.id; q('[data-express-quantity]').value = quantity;
      // Native accelerated checkout accepts one variant ID, including matching sets.
      q('[data-express]').hidden = busy || quantity > 1 || !allowed() || items.some(v => v.id !== first.id);
      q('[data-one-price]').textContent = money(first.price);
      q('[data-single-compare]').hidden = !(first.compareAt > first.price);
      if (first.compareAt > first.price) q('[data-single-compare]').textContent = money(first.compareAt);
      for (const [count, prefix] of [[2, 'two']]) {
        const preview = Array.from({length:count}, (_,i) => variantAt(i) || first);
        const amount = preview.reduce((sum,v) => sum + v.price - saving(v,count), 0);
        q('[data-two-unit-label]').textContent = preview.every(v => v.price === preview[0].price) ? 'each' : 'avg. each';
        const reference = preview.reduce((sum,v) => sum + referencePrice(v), 0);
        q(`[data-${prefix}-price]`).textContent = money(Math.round(amount / count));
        q(`[data-${prefix}-regular]`).textContent = money(Math.round(reference / count));
        q(`[data-${prefix}-regular]`).hidden = reference <= amount;
      }
      q('[data-two-savings]').textContent = `SAVE ${money(saving(first, 2) * 2)} ON TWO`;
      all('[data-color]').forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.color===String(first.id)));button.disabled=busy||!variants.find(v=>String(v.id)===button.dataset.color)?.available;});
      q('[data-availability]').textContent=first.available?'Available to order':'Sold out';
      q('[data-total]').textContent = money(total); q('[data-sticky-total]').textContent = money(total);
      const referenceTotal = items.reduce((sum,v) => sum + referencePrice(v), 0);
      q('[data-total-compare]').hidden = q('[data-sticky-compare]').hidden = referenceTotal <= total;
      q('[data-total-compare-value]').textContent = q('[data-sticky-compare-value]').textContent = money(referenceTotal);
      q('[data-set-summary]').textContent = `${quantity} ${quantity === 1 ? root.dataset.unit : root.dataset.plural}`;
      q('[data-sticky-title]').textContent = items.map(v => v.name).join(' + ');
      q('[data-sticky-photo]').src = first.photo;
      q('[data-buy-label]').textContent = busy ? 'Adding...' : allowed() ? 'Buy Now' : 'Selection unavailable';
      for (const selector of ['[data-buy]','[data-add]','[data-sticky-buy]']) q(selector).disabled = busy || !allowed();
      q('[data-sticky-buy]').textContent = busy ? 'Adding...' : allowed() ? 'Buy Now →' : 'Unavailable';
      const url = new URL(location.href);
      if (url.searchParams.has('variant') || String(first.id) !== root.dataset.selectedVariant) url.searchParams.set('variant', first.id);
      history.replaceState({...history.state, tenloveEvidenceFind:{product:root.dataset.product,quantity,ids:items.map(v=>String(v.id))}}, '', url);
    };
    const explicit = new URL(location.href).searchParams.get('variant');
    const stored = history.state?.tenloveEvidenceFind;
    if (stored?.product === root.dataset.product && [1,2].includes(stored.quantity) && (!explicit || stored.ids[0] === explicit)) {
      stored.ids.forEach((id,i) => {if (selects[i] && variants.some(v=>String(v.id)===id && v.available)) selects[i].value = id;});
      quantity = stored.quantity;
    }
    all('[data-color]').forEach(button=>button.addEventListener('click',()=>{selects[0].value=button.dataset.color;update();showFinish(variantAt(0));}));
    all('[data-bundle]').forEach(input => input.addEventListener('change', () => {quantity=Number(input.value);q('[data-error]').hidden=true;update();}));
    selects.forEach((select,i) => select.addEventListener('change', () => {q('[data-error]').hidden=true;update();if(i===0)showFinish(variantAt(0));}));
    const add = async checkout => {
      if (busy || !allowed()) return;
      busy=true; q('[data-error]').hidden=true; update();
      const counts=new Map(); selected().forEach(v=>counts.set(v.id,(counts.get(v.id)||0)+1));
      const controller=new AbortController(), timer=setTimeout(()=>controller.abort(),20000);
      try {
        const response=await fetch(`${route}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:controller.signal,body:JSON.stringify({items:[...counts].map(([id,quantity])=>({id,quantity}))})});
        const data=await response.json();
        if(!response.ok)throw new Error(data.description||data.message||'Please check your selection and try again.');
        const destination=checkout?'checkout':'cart';
        location.assign(quantity>=2?`${route}discount/${encodeURIComponent(root.dataset.discountCode)}?redirect=${encodeURIComponent(route+destination)}`:`${route}${destination}`);
      } catch(error) {
        q('[data-error]').textContent=error.name==='AbortError'||error instanceof TypeError?'We could not confirm the cart update. Please check your cart before trying again.':error.message;
        q('[data-error]').hidden=false;busy=false;update();
      } finally {clearTimeout(timer);}
    };
    q('[data-find-form]').addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();add(true);},true);
    q('[data-add]').addEventListener('click',()=>add(false));q('[data-sticky-buy]').addEventListener('click',()=>add(true));
    window.addEventListener('pageshow',()=>{busy=false;update();showFinish(variantAt(0));});
    const sync = () => {
      const visible = visibleSlides();
      const position = Math.max(0, Math.min(visible.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      activeIndex = slides.indexOf(visible[position]);
      all('[data-thumb]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.thumb) === activeIndex)));
    };
    all('[data-thumb]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.thumb))));
    track.addEventListener('scroll', sync, {passive:true});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const visible = visibleSlides();
      const position = visible.indexOf(slides[activeIndex]);
      const next = Math.max(0, Math.min(visible.length - 1, position + (event.key === 'ArrowRight' ? 1 : -1)));
      go(slides.indexOf(visible[next]));
    });
    let previousWidth = track.clientWidth;
    const resize = new ResizeObserver(() => {
      if (previousWidth === track.clientWidth) return;
      previousWidth = track.clientWidth;
      go(activeIndex, false);
    });
    resize.observe(track);

    // A jump can skip intersection changes entirely; scroll must also refresh it.
    const syncSticky = () => {
      const hidden = q('[data-buy]').getBoundingClientRect().top >= 0;
      if (q('[data-sticky]').hidden !== hidden) q('[data-sticky]').hidden = hidden;
    };
    const sticky = new IntersectionObserver(syncSticky); sticky.observe(q('[data-buy]'));
    window.addEventListener('scroll', syncSticky, {passive:true});
    window.addEventListener('resize', syncSticky, {passive:true});
    window.addEventListener('pageshow', syncSticky);
    syncSticky();
    const dialog=q('[data-lightbox]');
    all('[data-enlarge]').forEach(button=>button.addEventListener('click',()=>{const img=button.querySelector('img');q('[data-lightbox-image]').src=img.src;q('[data-lightbox-image]').alt=img.alt;q('[data-lightbox-caption]').textContent=img.alt;dialog.showModal();}));
    q('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    update(); showFinish(variantAt(0)); sync();
  };
  document.querySelectorAll('[data-pet-find]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pet-find]').forEach(init));
})();
